// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'nodes-down';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M5.063 11.811H1.688c-.622 0-1.125.504-1.125 1.125v3.375c0 .621.503 1.125 1.125 1.125h3.375c.62 0 1.125-.504 1.125-1.125v-3.375c0-.621-.504-1.125-1.125-1.125zM10.688.561H7.312c-.62 0-1.125.504-1.125 1.125v3.375c0 .621.504 1.125 1.125 1.125h3.375c.622 0 1.126-.504 1.126-1.125V1.686c0-.621-.504-1.125-1.126-1.125zm5.625 11.25h-3.375c-.622 0-1.126.504-1.126 1.125v3.375c0 .621.504 1.125 1.126 1.125h3.374c.622 0 1.125-.504 1.125-1.125v-3.375c0-.621-.503-1.125-1.125-1.125zm-12.938 0v-1.125A1.125 1.125 0 0 1 4.5 9.561h9a1.125 1.125 0 0 1 1.125 1.125v1.125M9 6.186v3.375'
  />
);

export const viewBox = '0 0 18 18';
